<template>
  <div class="row password-change">

    <!--<input type="text" v-model.trim="poruka" class="form-control" />-->
    <v-container fill-height fluid grid-list-xl>
      <v-layout justify-center
                wrap>
        <v-flex xs12 md10 lg8>
          <material-card :color="getTitleColorStore"
                         :title="$t('menu_password_change')"
                         :text="$t('security.password_change_descr')">
            <ProgressBar :loading="loading"></ProgressBar>
            <v-form ref="form">
              <v-container py-0>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-flex xs12 sm12>
                      <v-text-field v-model="password_old"
                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min]"
                                    :type="show1 ? 'text' : 'password'"
                                    name="input-10-1"
                                    :label="$t('security.password_OLD')"
                                    :hint="$t('security.rules.password_length', { 'count': getMinChars() })"
                                    counter
                                    @click:append="show1 = !show1"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12>
                      <v-text-field v-model="password_new"
                                    counter
                                    :rules="rules1"
                                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show2 ? 'text' : 'password'"
                                    :label="$t('security.password_NEW')"
                                    :hint="$t('security.rules.password_length', { 'count': getMinChars() })"
                                    @click:append="show2 = !show2"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12>
                      <v-text-field v-model="password_new_repeat"
                                    counter
                                    :rules="rules1"
                                    :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show3 ? 'text' : 'password'"
                                    :label="$t('security.password_NEW_repeat')"
                                    :hint="$t('security.rules.password_length', { 'count': getMinChars() })"
                                    @click:append="show3 = !show3"></v-text-field>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 sm12 md6>

                    <material-card class="v-card-profile">
                      <v-avatar slot="offset"
                                class="mx-auto d-block"
                                size="130">
                        <img src="/assets/images/icons/password.png">
                      </v-avatar>
                      <v-card-text class="text-xs-center">
                        <!--<h6 class="category text-gray font-weight-thin mb-3">CEO / CO-FOUNDER</h6>-->
                        <h4 class="card-title font-weight-light">{{$t('security.rules.title')}}</h4>
                        <p class="card-description font-weight-light">
                          <ul class="text-center no-bullets">
                            <li><small class="tim-not">{{$t('security.rules.password_characters')}} </small></li>
                            <li><small class="tim-not">{{$t('security.rules.password_characters_rules')}}</small></li>
                            <li><small class="tim-not">{{$t('security.rules.password_length', { 'count': getMinChars() })}}</small></li>
                          </ul>
                        </p>

                      </v-card-text>
                    </material-card>

                  </v-flex>
                  <v-flex xs12 text-xs-right>
                    <v-btn class="mx-0 font-weight-light" color="success" @click="saveNewPassword()" > <span class="white--text"> {{ $t('btnSave') }}</span></v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </material-card>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    //
  }
</script>


<script>
  import { createNamespacedHelpers, mapGetters } from 'vuex';
  const { mapState, mapMutations, mapActions } = createNamespacedHelpers('passChangeModule');


  export default {
    name: 'PasswordChange',
    computed: {
      ...mapState(['OldPass']),
      ...mapGetters({ getTitleColorStore: 'app/getTitleColor' }),
      // Samo primjer kako zapisati ne�to ako moramo u state - moramo preko mutacije
      //OldPassProp: {
      //  get() {
      //    return this.OldPass;
      //  },
      //  set(value) {
      //    this.setOldPassState(value);
      //  }
      //},
      rules1() {
        const rules1 = []
        if (this.min) {
          const rule = v => (v || '').length >= this.min || this.$t('security.rules.password_length', { count: this.min })
          rules1.push(rule)
        }
        if (!this.allowSpaces) {
          const rule = v => (v || '').indexOf(' ') < 0 || this.$t('validation_noSpaces')
          rules1.push(rule)
        }
        if (this.password_new) {
          const rule = v => (!!v && v) === this.password_new || this.$t('security.password_noMatch')
          rules1.push(rule)
        }
        return rules1
      }

    },
    methods: {
      ...mapMutations({ setOldPassState: 'SetOldPassState' }),
      ...mapActions({}),
      updateOldPassStore(e) {
        this.setOldPassState(e.target.value);
      },
      getMinChars() {
        return this.min;
      },
      
      validateField() {
        return this.$refs.form.validate();
      },
      saveNewPassword() {
        var isFormOK = this.validateField();

        var data = {
          LozinkaTrenutna: this.password_old,
          LozinkaZeljena: this.password_new
        }
        if (isFormOK) {
          this.loading = true;

          this.$fetchDataPromise('/api/Auth/ChangePassword', data)
            .then(x => this.$displaySuccess(x))
            .catch(x =>
            {
              this.$displayError(x);
            })
            .then(x => this.loading = false);
        }

      }
    },
    watch: {
      password_new: 'validateField',
      min: 'validateField',
      password_new: 'validateField',
    },
    mounted() {

    },

    data: function () {
      return {
        isFormOK: false,
        show1: false,
        show2: false,
        show3: false,
        show4: false,
        password_old: '',
        password_new: '',
        password_new_repeat: '',
        rules: {
          required: value => !!value || this.$t('validate.required_entry'),
          min: (v) => v.length >= this.getMinChars() || this.$t('security.rules.password_length', { count: 7 }),
          password_newMatch: v => (!!v && v) === this.match || 'Values do not match',
          nospaces: v => (v || '').indexOf(' ') < 0 || 'No spaces are allowed'
        },
        allowSpaces: false,
        min: 7,
        loading: false
      }
    },

    components: {
    }
  }
</script>

<style scoped lang="scss">
  .password-change {
    /*background-color: greenyellow;*/
    margin: 0px;
  }

  .no-bullets {
    list-style: inside decimal;
  }
</style>



// WEBPACK FOOTER //
// VueSrc/Security/PasswordChange.vue